/* =======================================================
   📂 custom-menu.js — NaturQuality
   يحتوي على: القائمة + الفلاتر + ربط عنوان المنتج بالرابط
   ======================================================= */

document.addEventListener('DOMContentLoaded', function () {
  /* ===============================
     ✅ القائمة الرئيسية والقوائم الفرعية
     =============================== */
  const menuToggle = document.querySelector('.menu-toggle');
  const menuDropdown = document.getElementById('menu-dropdown');

  // فتح/إغلاق القائمة الرئيسية
  if (menuToggle) {
    menuToggle.querySelector('button').addEventListener('click', () => {
      menuToggle.classList.toggle('active');
    });
  }

  // إغلاق القائمة عند الضغط خارجها
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.menu-dropdown') && !event.target.closest('.menu-toggle')) {
      menuToggle?.classList.remove('active');
      document.querySelectorAll('.has-submenu').forEach(item => item.classList.remove('active'));
    }
  });

  // فتح/إغلاق القوائم الفرعية عند الضغط
  document.querySelectorAll('[data-submenu]').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const parent = this.closest('.has-submenu');

      // إغلاق الكل أولًا
      document.querySelectorAll('.has-submenu').forEach(item => {
        if (item !== parent) item.classList.remove('active');
      });

      // ثم تبديل الحالي
      parent.classList.toggle('active');
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  /* ===============================
     ✅ تفعيل الفلاتر حسب الرابط
     =============================== */
  const params = new URLSearchParams(window.location.search);

  // فلاتر الفيتامينات
  const vitaminType = params.get("filter.p.m.custom.vitamin_type");
  if (vitaminType) {
    document.querySelectorAll(".custom-metafilter .pill").forEach(function (pill) {
      if (pill.href.toLowerCase().includes(vitaminType.toLowerCase())) {
        pill.classList.add("active");
      }
    });
  }

  // فلاتر الكريمات
  const creamType = params.get("filter.p.m.custom.cream_type");
  if (creamType) {
    document.querySelectorAll(".custom-metafilter .pill").forEach(function (pill) {
      if (pill.href.toLowerCase().includes(creamType.toLowerCase())) {
        pill.classList.add("active");
      }
    });
  }
});


document.addEventListener('DOMContentLoaded', function () {
  /* ===============================
     ✅ ربط عنوان المنتج برابط الصورة
     =============================== */
  document.querySelectorAll('.product-card').forEach(function (card) {
    const link = card.querySelector('a[href*="/products/"]'); // رابط الصورة
    const title = card.querySelector('.product-card-title');   // العنوان

    if (link && title) {
      title.style.cursor = 'pointer'; // يخلي الماوس شكل يد
      title.addEventListener('click', function () {
        window.location.href = link.href; // يفتح نفس رابط الصورة
      });
    }
  });
});



/* ===============================
   ✅ التحكم في شريط البحث (Top Bar)
   =============================== */
document.addEventListener('DOMContentLoaded', function () {
  const topBar    = document.querySelector('.top-bar');          // الشريط العلوي
  const toggleBtn = topBar?.querySelector('.search-toggle');     // زر فتح/إغلاق البحث
  const searchBar = topBar?.querySelector('.search-bar');        // عنصر البحث نفسه

  if (topBar && toggleBtn && searchBar) {
    // عند الضغط على زر البحث → فتح/إغلاق شريط البحث
    toggleBtn.addEventListener('click', function (e) {
      e.stopPropagation(); // يمنع إغلاقه فوراً بالضغط
      topBar.classList.toggle('search-active');
    });

    // إغلاق البحث عند الضغط في أي مكان خارج الـTop Bar
    document.addEventListener('click', function (e) {
      if (!topBar.contains(e.target)) {
        topBar.classList.remove('search-active');
      }
    });

    // منع الإغلاق عند الضغط داخل شريط البحث نفسه
    searchBar.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }
});




/* ===============================
   ✅ تفعيل زر الترتيب الصحيح في صفحة "كل المنتجات"
   =============================== */
document.addEventListener("DOMContentLoaded", function () {
  const url = new URL(window.location.href);
  const sortBy = url.searchParams.get("sort_by");
  const allBtn = document.getElementById("all-products-button");
  const bestBtn = document.getElementById("bestseller-button");

  if (sortBy === "best-selling") {
    bestBtn?.classList.add("active");
  } else {
    // اعتبرنا 'date-desc' أو عدم وجود باراميتر = "كل المنتجات"
    allBtn?.classList.add("active");
  }
});


/* ===============================
   ✅ إعادة التوجيه إلى السلة بعد الإضافة
   =============================== */
function handleCartRedirect(event) {
  event.preventDefault();
  const form = event.target;
  const formData = new FormData(form);

  fetch('/cart/add.js', { method: 'POST', body: formData }).then(() => {
    const isArabic = window.location.pathname.startsWith('/ar');
    window.location.href = isArabic ? '/ar/cart' : '/cart';
  });
}


/* ===============================
   ✅ تفعيل الفلتر النشط (Pill)
   =============================== */
document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll('.pill');
  const currentUrl = window.location.href;
  links.forEach(function(link) {
    if (link.href === currentUrl) {
      link.classList.add('active');
    }
  });
});





/* ==============================
⭐ START: Product Accordion (JS)
- الوصف يبدأ مفتوح (active)
- فتح/إغلاق بانسيابي (مرحلة واحدة فقط)
- تحديث aria-expanded لدعم الوصول
- استخدام ResizeObserver لضمان ظهور كل المحتوى حتى لو تغيّر
============================== */
document.addEventListener("DOMContentLoaded", function() {
  const headers = document.querySelectorAll(".accordion-header");

  headers.forEach(header => {
    const item = header.parentElement;
    const body = item.querySelector(".accordion-body");

    // ضبط aria-expanded وحالة max-height عند التحميل
    if (item.classList.contains("active")) {
      header.setAttribute("aria-expanded", "true");
      body.style.maxHeight = body.scrollHeight + "px";
    } else {
      header.setAttribute("aria-expanded", "false");
      body.style.maxHeight = "0";
    }

    header.addEventListener("click", function() {
      const isActive = item.classList.contains("active");

      if (isActive) {
        // إغلاق بانسيابي
        body.style.maxHeight = body.scrollHeight + "px"; // يضبط الطول الحالي
        setTimeout(() => {
          body.style.maxHeight = "0";
        }, 10);
        item.classList.remove("active");
        header.setAttribute("aria-expanded", "false");
      } else {
        // فتح بانسيابي + تحديث ديناميكي للحجم
        item.classList.add("active");
        body.style.maxHeight = body.scrollHeight + "px";
        header.setAttribute("aria-expanded", "true");

        // مراقبة أي تغييرات داخل القسم (مثلاً تغيّر اللغة أو حجم النص)
        const resizeObserver = new ResizeObserver(() => {
          if (item.classList.contains("active")) {
            body.style.maxHeight = body.scrollHeight + "px";
          }
        });
        resizeObserver.observe(body);
      }
    });
  });
});
/* ==============================
⭐ END: Product Accordion (JS)
============================== */

